import type { TranslationMessages } from '../types';

export const menu: TranslationMessages = {
  sales: 'Bán hàng',
  catalog: 'Sản phẩm',
  customers: 'Khách hàng',
  library: 'Thư viện',
  memberships: 'Thành viên',
  staff: 'Quản lý nhân viên',
  staff_profiles: 'Hồ sơ nhân viên',
  organization: 'Tổ chức',
  financial: 'Quản lý tài chính',
  system: 'Hệ thống',
  zalo: 'Tích hợp Zalo',
};
